export default {
	ApiUrl:'https://p4.energyshifft.com',
	client_id:2, 
	client_secret:'uh2SOknWVTrH3YEhPmr52gLnasVUgBPBqKbBAWNM', 
}